
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({})
export default class SubscriptionDetails extends Vue {
  @Prop() subData!: any;

  get fields() {
    return this.subData.fields;
  }

  get checkins() {
    return this.subData.checkins;
  }
}
